import axios, { buildApi } from '@/libs/api.request';
let name = '/user/robot'

export const apis = buildApi({
  curd: name
})